// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// NGB bootstrap
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';

// Custom component
import { CheckboxComponent } from './components/checkbox/checkbox.component';
import { TextboxComponent } from './components/textbox/textbox.component';
import { ChipComponent } from './components/chip/chip.component';
import { SelectComponent } from './components/select/select.component';
import { RadioComponent } from './components/radio/radio.component';
import { DatepickerComponent } from './components/datepicker/datepicker.component';
import { TimepickerComponent } from './components/timepicker/timepicker.component';
import { TextareaComponent } from './components/textarea/textarea.component';
import { SeparatorComponent } from './components/separator/separator.component';
import { FileUploaderComponent } from './components/file-uploader/file-uploader.component';

// Layout
import { SaeculumAngularFormlyLayoutComponent } from './pages/saeculum-angular-formly-layout/saeculum-angular-formly-layout';
import { SaeculumAngularFormlyFieldComponent } from './components/reactive-fields-component/reactive-field-component';
// import { FormArrayComponent } from './components/form-array/form-array.component';
import { FormValidationMessageComponent } from './components/form-validation-message/form-validation-message.component';
import { SafeUrlPipe } from './directives/safe-url.pipe';
import { NumberDirective } from './components/shared/directives/numbers-only.directive';
import { CheckboxListComponent } from './components/checkbox-list/checkbox-list.component';
import { TypeaheadComponent } from './components/typeahead/typeahead.component';
import { HttpClientModule } from '@angular/common/http';
import { NoSpecialCharDirective } from './components/shared/directives/no-special-char.directive';
import { NgInitDirective } from './components/shared/directives/ng-init.directive';

@NgModule({
    imports: [
        HttpClientModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NgSelectModule,
        NgbModule,
    ],
    declarations: [
        NumberDirective,
        NoSpecialCharDirective,
        SafeUrlPipe,
        NgInitDirective,
        SaeculumAngularFormlyLayoutComponent,
        CheckboxComponent,
        TextboxComponent,
        ChipComponent,
        SelectComponent,
        RadioComponent,
        DatepickerComponent,
        TimepickerComponent,
        TextareaComponent,
        SeparatorComponent,
        FileUploaderComponent,
        SaeculumAngularFormlyFieldComponent,
        CheckboxListComponent,
        FormValidationMessageComponent,
        TypeaheadComponent,
    ],
    exports: [
        SafeUrlPipe,
        SaeculumAngularFormlyLayoutComponent,
        CheckboxComponent,
        TextboxComponent,
        ChipComponent,
        SelectComponent,
        RadioComponent,
        DatepickerComponent,
        SaeculumAngularFormlyFieldComponent,
        TimepickerComponent,
        SeparatorComponent,
        TextareaComponent,
        FileUploaderComponent,
        CheckboxListComponent,
        TypeaheadComponent,
        NgSelectModule,
        FormValidationMessageComponent,
        NgbModule
    ]
})

export class SaeculumAngularFormlyModule { }
